import { UsageProduct } from '../../usage';
import { UsageReport } from '../../usage/interfaces/usage-report.interface';

export const isUsageLogsExist = (usageReportsByProduct?: UsageProduct[]) => {
  return !!usageReportsByProduct?.some(
    (usageProduct) =>
      !!usageProduct?.usageReports?.some((usageReport: UsageReport) => usageReport.usageLogsTable.rows.length != 0),
  );
};
